import { useEffect , useState} from "react";
import { paddingHorizontal } from "../../../utils/sizing";
import TextInput from "../../common/input";
import i18next from "i18next";

function EditableSocialSection({
  socialMediaData,
  onSetSocialMediaLink,
  onSetApiSocialLinks,
}) {
  const currentLanguage = i18next.language;
  const [socialData, setSocialData] = useState([]);
  
  const handleCheckChange = (index) => {
    const updatedSocialLinks = socialMediaData.map((item, i) =>
      i === index
        ? {
            ...item,
            text: item.text,
            check: !item.check,
          }
        : item
    );
    console.log(
      "handleCheckChange ------------>",
      updatedSocialLinks
    );

    onSetApiSocialLinks(updatedSocialLinks);
    onSetSocialMediaLink(updatedSocialLinks);
  };

  const handleLinkChange = (index, newLink) => {
    console.log('social field index', index, 'user typed text', newLink);
    console.log('complete social media data', socialMediaData);
    console.log('current social media data', filterTranslation(socialMediaData, currentLanguage));

    const updatedSocialMediaData = socialMediaData.map((item, itemIndex) => {
      item.translation.forEach((itemTranslation, itemTranslationIndex) => {
        if (itemTranslation.languageCode === currentLanguage) {
          let socialArray = JSON.parse(itemTranslation.languageText);
          socialArray = socialArray.map((socialItem, socialIndex) => {
            let match = socialIndex === index;
            if (match) {
              socialItem.text = i18next.t(socialItem.text);
              socialItem.link = newLink; // Update the link
            }
            return socialItem;
          });
          console.log('reached at bottom', socialArray);

          item.translation[itemTranslationIndex].languageText = JSON.stringify(socialArray);
        }
      });
      return item;
    });

    console.log('updated social media data', updatedSocialMediaData);
    onSetSocialMediaLink(updatedSocialMediaData);
  };

  const filterTranslation = (data, currentLanguage) => {
    const updatedData = data.map(item => {
      return {
        ...item,
        translation: data[0].translation.filter(translation => translation.languageCode === currentLanguage)
      };
    });
    return updatedData;
  };

  useEffect(() => {
    // Ensure that you're getting the filtered translation based on the currentLanguage
    const filteredTranslation = filterTranslation(socialMediaData, currentLanguage);
    console.log('filtered translation', filteredTranslation);
    
    if (filteredTranslation[0]?.translation?.length > 0) {
      let socialItems = filteredTranslation[0].translation[0].languageText;
      socialItems = JSON.parse(socialItems);
      const updatedItems = socialItems && socialItems.map(item => ({
        ...item,
        check: true
      }));
      
      console.log('updated social items------------>', updatedItems);
      // Set state once after processing all items
      setSocialData(updatedItems);
    }
  }, [currentLanguage, socialMediaData]);

  return (
    <div className={`${paddingHorizontal} items-center text-center`}>
      <div className="w-max flex flex-row space-x-5 mt-10 border-b pb-4">
        <div>
          <div className="py-8 pb-20 w-full justify-center flex flex-row space-x-5 items-center">
            {
              socialData?.map((item, index) => (
                <SocialTextField
                  placeholder={`Enter ${item.text} Link`}
                  key={index}
                  value={item.text}
                  check={item.check}
                  link={item.link}
                  onCheckChange={() => handleCheckChange(index)}
                  onLinkChange={(newLink) => handleLinkChange(index, newLink)}
                />
              ))
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditableSocialSection;

function SocialTextField({
  value,
  placeholder,
  check,
  link,
  onCheckChange,
  onLinkChange,
}) {
  return (
    <div className="h-28 min-w-96">
      <div className="space-x-2 flex flex-row">
        <span className="text-lg text-gray-700">{value}</span>
        <input
          type="checkbox"
          className="-mb-10 h-5 w-5"
          checked={check}
          onChange={onCheckChange}
        />
      </div>  
      {check && (
        <TextInput
          className="w-full mt-2"  // Changed from style to className
          placeholder={placeholder}
          value={link}
          onChange={(e) => onLinkChange(e.target.value)}
        />
      )}
    </div>
  );
}